//////////////// Header Record Headers Columns ///////////////////////
export const HeaderRecordHeaderColumns = [
  {
    field: "recordCount",
    headerName: "Record Count",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 1,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "recordType",
    headerName: "Record Type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 2,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "code",
    headerName: "Code",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 3,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientName",
    headerName: "Client Name",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 4,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 5,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "fileNumber",
    headerName: "File Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 6,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "creationDate",
    headerName: "Creation Date",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 7,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "currency",
    headerName: "Currency",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 8,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "inputType",
    headerName: "Input Type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 9,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 10,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res2",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 11,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res3",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res4",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "Filer2",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "optionalRec",
    headerName: " Optional Rec",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
];

//////////////// Basic Payment Record Headers Columns ///////////////////////
export const BasicPaymentRecordHeaderColumns = [
  {
    field: "recordCount",
    headerName: "Record Count",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 1,
    frozenColumn: false,
    footer: null,
    minWidth: 120,
    maxWidth: 120,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "recordType",
    headerName: "Record Type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 2,
    frozenColumn: false,
    footer: null,
    minWidth: 105,
    maxWidth: 105,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "code",
    headerName: "Code",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 3,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientNumber",
    headerName: "Client Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 4,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 5,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 6,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentNumber",
    headerName: "Payment Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 7,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "financialInstitutionNumber",
    headerName: "Fin Inst No.",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 8,
    frozenColumn: false,
    footer: null,
    minWidth: 100,
    maxWidth: 100,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "financialInstitutionBranchNumber",
    headerName: "Fin Inst Branch No.",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 9,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "accountNo",
    headerName: "Acc No",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 10,
    frozenColumn: false,
    footer: null,
    minWidth: 180,
    maxWidth: 180,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer2",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 11,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "amount",
    headerName: "Amount",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 340,
    maxWidth: 340,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentDate",
    headerName: "Payment Date",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "lan",
    headerName: "LAN",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentMedium",
    headerName: " Payment Medium",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientShortName",
    headerName: "Client Short Name",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "currency",
    headerName: "Curr",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res2",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "desCountry",
    headerName: "Des Country",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 120,
    maxWidth: 120,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer3",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res3",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "optionalRecord",
    headerName: "Optional Record",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 130,
    maxWidth: 130,
    fieldName: null,
    edr: "edr",
  },
];



//////////////// Basic Payment Record Headers Columns ///////////////////////
export const BasicPaymentRecordHeaderColumnsForView = [
  {
    field: "recordCount",
    headerName: "Record Count",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 1,
    frozenColumn: false,
    footer: null,
    minWidth: 120,
    maxWidth: 120,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "recordType",
    headerName: "Record Type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 2,
    frozenColumn: false,
    footer: null,
    minWidth: 105,
    maxWidth: 105,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "code",
    headerName: "Code",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 3,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientNumber",
    headerName: "Client Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 4,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 5,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "customerNumber",
    headerName: "Customer Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 6,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentNumber",
    headerName: "Payment Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 7,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "financialInstitutionNumber",
    headerName: "Fin Inst No.",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 8,
    frozenColumn: false,
    footer: null,
    minWidth: 100,
    maxWidth: 100,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "financialInstitutionBranchNumber",
    headerName: "Fin Inst Branch No.",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 9,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "accountNo",
    headerName: "Acc No",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 10,
    frozenColumn: false,
    footer: null,
    minWidth: 180,
    maxWidth: 180,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer2",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 11,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "amount",
    headerName: "Amount",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentDate",
    headerName: "Payment Date",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "customerName",
    headerName: "Customer Name",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "lan",
    headerName: "LAN",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "paymentMedium",
    headerName: " Payment Medium",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientShortName",
    headerName: "Client Short Name",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 150,
    maxWidth: 150,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "currency",
    headerName: "Curr",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res2",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "desCountry",
    headerName: "Des Country",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 120,
    maxWidth: 120,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer3",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res3",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 80,
    maxWidth: 80,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "optionalRecord",
    headerName: "Optional Record",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: 130,
    maxWidth: 130,
    fieldName: null,
    edr: "edr",
  },
];

//////////////// Trailer Record Headers Columns ///////////////////////
export const TrailerRecordHeaderColumns = [
  {
    field: "recordCount",
    headerName: "Record Count",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 1,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "recordType",
    headerName: "Record Type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 2,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "code",
    headerName: "Code",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 3,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientNumber",
    headerName: "Client Number",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 4,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 5,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res2",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 6,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "totalTransactions",
    headerName: "Total Trans",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 7,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "totalAmount",
    headerName: "Total Amount",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 8,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "totalClientOptionalRec",
    headerName: "Total Client Optional Rec",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 9,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "totalCustomerOptionalRec",
    headerName: "Total Customer Optional Rec",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 10,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer",
    headerName: "Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res3",
    headerName: "Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "Filer2",
    headerName: " Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "res4",
    headerName: " Res",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "filer3",
    headerName: " Filer",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 12,
    frozenColumn: false,
    footer: null,
    minWidth: null,
    maxWidth: null,
    fieldName: null,
    edr: "edr",
  },
];

//////////////// BasicPaymentRecordAmountHeaderColumns ///////////////////////
export const BasicPaymentRecordAmountHeaderColumns = [
  {
    field: "type",
    headerName: "type",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 1,
    frozenColumn: false,
    footer: "Total",
    minWidth: 30,
    maxWidth: 30,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "clientName",
    headerName: "CN",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "left",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 2,
    frozenColumn: false,
    footer: null,
    minWidth: 30,
    maxWidth: 30,
    fieldName: null,
    edr: "edr",
  },
  {
    field: "amount",
    headerName: "amount",
    description: "",
    flex: 1,
    hide: false,
    hideable: false,
    sortable: true,
    sortingOrder: "asc",
    resizable: false,
    type: "string",
    align: "right",
    headerAlign: "center",
    hideSortIcons: false,
    disableColumnMenu: true,
    disableReorder: true,
    disableExport: true,
    maskable: false,
    isFixed: true,
    isEditable: true,
    sequence: 3,
    frozenColumn: false,
    footer: null,
    minWidth: 25,
    maxWidth: 25,
    fieldName: null,
    edr: "edr",
  },
];
